import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  beneEditDetailBank,
  resetEditBankBeneficiary,
} from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import {
  beneBankLookUp,
  beneVerifyThisBank,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { viewAccountDetail } from "../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import FieldForceBankEdit from "../FieldForceBankEdit";
import FieldForceEditConfirm from "../FieldForceEditConfirm";
import "./index.css";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";

const FieldForceMainEditBank = () => {
  const [bankIsPending, setBankIsPending] = useState(false);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [bankIsAchived, setBankIsArchived] = useState(false);
  const [bankIsApproved, setBankIsApproved] = useState(false);
  const [bankSelectedItem, setBankSelectedItem] = useState(null);
  const [bankDisableCreateNext, setBankDisableCreateNext] = useState(false);
  const [bankShutViewAll, setBankShutViewAll] = useState(false);
  const [bankAccountType, setBankAccountType] = useState({ type: "", id: "" });
  const [bankIsDennied, setBankIsDennied] = useState(false);
  const [bankIsRejected, setBankIsRejected] = useState(false);
  const [verifiedBank] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [bankNextButtonEnabled, BenEnableNextButton] = useState(true);
  const [newBankMessage, setBankNewMessage] = useState(false);
  const [hideBankCreate, setBankHideCreate] = useState(false);
  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [active, setActive] = useState(false);
  const [openEditBankPop, setOpenEditBankPop] = useState(false);
  const [createNewedit, setCreateNewEdit] = useState(false);
  const [bankUnachivedOpenPop, setBankUnachivedOpenPop] = useState(false);
  const [bankAchivedOpenPop, setBankAchivedOpenPop] = useState(false);
  const [timer, setTimer] = useState(false);
  const scrollIt = useRef(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    email_id: "",
    pan_no: "",
    bank_name: "",
    contact_no: "",
    legal_name: "",
    old_bank_account: "",
    old_ifsc_code: "",
    name: "",
    gstin_detail: "",
  });

  const { beneEditDetailBankData, beneEditDetailBankLoading } = useSelector(
    (state) => state.beneCreateAccount,
  );
  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const { verifyBankisLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  useEffect(() => {
    const fetchBankData = async () => {
      let response = await dispatch(viewAccountDetail({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchBankData();
  }, [dispatch, id, navigate]);

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  useEffect(() => {}, [viewAccountDetailData]);
  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      setPayload({
        ...payload,
        name: viewAccountDetailData?.beneficiary_accounts[0]?.name,
        bank_account:
          viewAccountDetailData?.beneficiary_accounts[0]?.bank_acc_no,
        ifsc_code: viewAccountDetailData?.beneficiary_accounts[0]?.ifsc_code,
        bank_name: viewAccountDetailData?.beneficiary_accounts[0]?.bank_name,
        pan_no: viewAccountDetailData?.beneficiary_accounts[0]?.pan_no,
        email_id: viewAccountDetailData?.beneficiary_accounts[0]?.email_id,
        contact_no: viewAccountDetailData?.beneficiary_accounts[0]?.contact_no,
        legal_name:
          viewAccountDetailData?.beneficiary_accounts[0]?.pan_legal_name,
        old_bank_account:
          viewAccountDetailData?.beneficiary_accounts[0]?.bank_acc_no,
        old_ifsc_code:
          viewAccountDetailData?.beneficiary_accounts[0]?.ifsc_code,
        gstin_detail:
          viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail,
      });
    }
  }, [viewAccountDetailData]);
  const handleBackBank = () => {
    if (activeStep === 0) {
      if (createNewedit) {
        setOpenEditBankPop(true);
      } else {
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      if (scrollIt.current) {
        scrollIt.current.scrollLeft -= ScreenSizeConfiguration.tabviewEnd;
      }
    }
  };
  const handleUpdateBank = () => {
    const type = "ReimbursementBankEdit";
    if (activeStep === 0) {
      handleNextBank();
    } else {
      dispatch(
        beneEditDetailBank({
          id: id,
          bank_account: payload.bank_account,
          ifsc_code: payload.ifsc_code,
          navigate,
          type,
        }),
      );
    }
  };

  let newBeneId = beneEditDetailBankData?.beneficiary_accounts[0]?.id || "";

  useEffect(() => {
    if (beneEditDetailBankData?.status === true) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details_success/${newBeneId}`,
      );
      dispatch(resetEditBankBeneficiary());
    } else if (
      !beneEditDetailBankLoading &&
      beneEditDetailBankData?.status === false
    ) {
      CommonToast({
        text: Object.values(beneEditDetailBankData?.errors)[0][0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  }, [beneEditDetailBankData]);

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    ifscRegex.test(payload?.ifsc_code);

  useEffect(() => {
    setTimer(false);
    const foundAccount = benebankLookData?.beneficiary_accounts?.find((val) => {
      if (!verifyBankisLoading) {
        if (
          payload?.old_bank_account === val?.bank_acc_no &&
          payload?.old_ifsc_code === val?.ifsc_code
        ) {
          BenEnableNextButton(true);
        }
        if (
          payload?.bank_account.length >=
            GlobalConfiguration.accountnormalLength &&
          payload?.ifsc_code.length >= GlobalConfiguration.ifscLength
        ) {
          if (
            payload?.old_bank_account === payload?.bank_account &&
            payload?.old_ifsc_code === payload?.ifsc_code
          ) {
            BenEnableNextButton(true);
          } else if (
            Validation.validateBankAcc(payload?.bank_account) &&
            Validation.validateIfsc(payload?.ifsc_code)
          ) {
            BenEnableNextButton(false);
          }
        }
      }

      if (
        payload?.pan_no === val?.pan_no &&
        payload?.old_bank_account !== val?.bank_acc_no &&
        (payload?.old_ifsc_code === val?.ifsc_code ||
          payload?.old_ifsc_code) !== val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        BenEnableNextButton(true);
        return true;
      }

      setTimeout(() => {
        setTimer(true);
      }, IntervalConfiguration.intervalMedium);
      return false;
    });

    if (!foundAccount) {
      setIsBankLinkedAccount(false);
    }
  }, [benebankLookData, payload]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !bankNextButtonEnabled,
      stepperText: "Bank details",
    },
    {
      previousText: "Previous",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !bankNextButtonEnabled,
      stepperText: "Confirm and create",
    },
  ];

  const handleNextBank = () => {
    if (activeStep === 1) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/bank_edit_success/${id}`,
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (scrollIt.current) {
        scrollIt.current.scrollLeft += ScreenSizeConfiguration.tabviewEnd;
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
      if (event.key === "Tab") {
        event.preventDefault();
      }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!payload?.bank_account && payload?.ifsc_code) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      BenEnableNextButton(true);
      setIsBankLinkedAccount(false);
    }
    if (
      payload?.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (
      payload?.bank_account?.length >=
        GlobalConfiguration.accountnormalLength &&
      payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code)
    ) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
        dispatch(
          beneVerifyThisBank({
            ifsc_code: payload?.ifsc_code,
            bank_account: payload?.bank_account,
            legal_name: payload?.legal_name,
            navigate: navigate,
          }),
        );
        if (bankStatus?.verification_details[0].is_virtual === "N") {
          dispatch(
            beneBankLookUp({
              ifsc: payload.ifsc_code,
              bank_account_no: payload.bank_account,
            }),
          );
        }
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [
    payload?.ifsc_code,
    payload?.bank_account,
    bankStatus?.verification_details[0].is_virtual,
  ]);

  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  return (
    <div
      className="edit_bank_con_main !h-screen"
      style={{
        overflowY: openEditBankPop ? "hidden" : "hidden",
        height:
          openEditBankPop || bankUnachivedOpenPop || bankAchivedOpenPop
            ? "var(--full-height)"
            : "",
      }}
    >
      <div className="hidden Qsmd:block min-h-navbar-breadcrumb-height"></div>
      {openEditBankPop && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Are you sure you want to leave this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenEditBankPop(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="main_edit_stepper_div z-z-index-header">
        <div className="w-full Qsmd:w-std-width relative min-h-stepper-height Qsmd:top-top-base top-[calc(-1*var(--padding-sm))]">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleUpdateBank}
            handleBackwardAction={handleBackBank}
            dataArray={dataArray}
          />
        </div>
      </div>

      {/* <div className="Qsmd:h-navbar-breadcrumb-height min-h-[var(--navbar-height)]"></div> */}
      <div className="top_bar_btn_resp_edit Qsmd:hidden flex">
        <TopNavComponent
          isFormattingNotRequired
          topNavHeader={"Field force account"}
          topNavSubText="Bank details"
          handleBack={handleBackBank}
        />
      </div>
      <div
        className="edit_bank_details_all no-scrollbar Qsmd:pt-padding-lg pt-stepper-gap-between mt-margin-sm Qsmd:mt-margin-base flex-col px-padding-md Qlg:px-padding-base"
        ref={scrollIt}
      >
        {activeStep === 0 ? (
          <FieldForceBankEdit
            bankIsAchived={bankIsAchived}
            handleNextBank={handleNextBank}
            setBankIsArchived={setBankIsArchived}
            setBankIsApproved={setBankIsApproved}
            bankIsApproved={bankIsApproved}
            bankSelectedItem={bankSelectedItem}
            setBankSelectedItem={setBankSelectedItem}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setBankIsPending={setBankIsPending}
            bankIsPending={bankIsPending}
            bankIsDennied={bankIsDennied}
            bankIsRejected={bankIsRejected}
            setBankIsDennied={setBankIsDennied}
            setBankIsRejected={setBankIsRejected}
            BenEnableNextButton={BenEnableNextButton}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            payload={payload}
            setPayload={setPayload}
            setBankShutViewAll={setBankShutViewAll}
            bankShutViewAll={bankShutViewAll}
            setBankDisableCreateNext={setBankDisableCreateNext}
            bankDisableCreateNext={bankDisableCreateNext}
            bankAccountType={bankAccountType}
            setBankAccountType={setBankAccountType}
            verifiedBank={verifiedBank}
            active={active}
            setActive={setActive}
            newBankMessage={newBankMessage}
            setBankNewMessage={setBankNewMessage}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            hideBankCreate={hideBankCreate}
            setBankHideCreate={setBankHideCreate}
            previousBankID={id}
            isBankLinkedAccount={isBankLinkedAccount}
            createNewedit={createNewedit}
            setCreateNewEdit={setCreateNewEdit}
            bankUnachivedOpenPop={bankUnachivedOpenPop}
            setBankUnachivedOpenPop={setBankUnachivedOpenPop}
            bankAchivedOpenPop={bankAchivedOpenPop}
            setBankAchivedOpenPop={setBankAchivedOpenPop}
            timer={timer}
            setTimer={setTimer}
            benebankLookData={benebankLookData}
            isIFSCValid={isIFSCValid}
            verifyBankisLoading={verifyBankisLoading}
            setIsBankLinkedAccount={setIsBankLinkedAccount}
          />
        ) : (
          <FieldForceEditConfirm
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            payload={payload}
          />
        )}
        <div className="h-px py-padding-sm"></div>
      </div>
      <div className="Qsmd:hidden block min-h-pagination-height"></div>
    </div>
  );
};

export default FieldForceMainEditBank;
